<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank">晋ICP备2023020541号-1</a>
        </p>
        <p>
          {{ new Date().getFullYear() }} — <strong>山西万顺和商贸有限公司</strong> — 版权所有
        </p>
      </v-card-text>

      <v-card-text class="white--text">
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-web",
        link: "https://static.sl.dande.online/ak",
      },
    ],
  }),
};
</script>
